// src/styles/scrollbar.styles.js
import { css } from 'lit';

export const scrollbarStyles = css`
  ::-webkit-scrollbar {
    width: 4px;
    height: 4px;
    display: none;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: rgba(108, 108, 108, 0.6);
    border-radius: 2px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: rgba(108, 108, 108, 0.8);
  }

  * {
    scrollbar-width: none;
    scrollbar-color: rgba(108, 108, 108, 0.6) transparent;
    -ms-overflow-style: none;
  }
`;
